var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklistNoDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_156",
    "data-name": "Raggruppa 156",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_170",
    "data-name": "Tracciato 170",
    d: "M15,30A15,15,0,1,1,30,15,15,15,0,0,1,15,30Z",
    fill: "#96a1a8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_171",
    "data-name": "Tracciato 171",
    d: "M17.554,12.432a1.982,1.982,0,1,1,1.982-1.982A1.982,1.982,0,0,1,17.554,12.432Z",
    transform: "translate(3.886 2.113)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_172",
    "data-name": "Tracciato 172",
    d: "M7.245,12.432A1.982,1.982,0,1,1,9.227,10.45,1.983,1.983,0,0,1,7.245,12.432Z",
    transform: "translate(1.314 2.113)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_173",
    "data-name": "Tracciato 173",
    d: "M19.277,17.955a.641.641,0,0,1-.427.8.729.729,0,0,1-.188.034.635.635,0,0,1-.615-.461,5.1,5.1,0,0,0-9.653-.017.643.643,0,0,1-1.23-.376,6.384,6.384,0,0,1,12.113.017Z",
    transform: "translate(1.77 3.387)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_174",
    "data-name": "Tracciato 174",
    d: "M19.58,8.875a.368.368,0,0,1-.188-.034l-3.81-1.128a.643.643,0,0,1,.376-1.23l3.81,1.128a.647.647,0,0,1-.188,1.264Z",
    transform: "translate(3.773 1.612)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_175",
    "data-name": "Tracciato 175",
    d: "M5.26,7.624,9.069,6.5a.643.643,0,0,1,.376,1.23L5.635,8.854a.726.726,0,0,1-.188.034.656.656,0,0,1-.615-.461A.647.647,0,0,1,5.26,7.624Z",
    transform: "translate(1.199 1.616)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistNoDisabled);
export default __webpack_public_path__ + "static/media/ChecklistNoDisabled.4ee64106864eaf68c7c3aeea3c3dd4d5.svg";
export { ForwardRef as ReactComponent };